import React, { useEffect } from 'react';
import { UserProvider } from '../../context/UserContext';
import { getAuthToken, logout } from '../../lib/auth';
import client from '../../lib/client';
import { currentUserQuery } from '../../queries/user';
import { CurrentUserQuery } from '../../queries/__generated__/CurrentUserQuery';

const PleaseSignIn: React.FC = ({ children }) => {
  useEffect(() => {
    const token = getAuthToken();
    if (!token) {
      logout();
    }

    async function checkIfUserExists() {
      await client
        .query<CurrentUserQuery>({
          query: currentUserQuery,
          fetchPolicy: 'network-only'
        })
        .then(res => {
          const me = res.data.me;

          if (me === null) {
            logout();
          }
        });
    }
    checkIfUserExists();
  }, []);

  return <UserProvider>{children}</UserProvider>;
};

export default PleaseSignIn;
